import { render } from "./TeamLibrary.vue?vue&type=template&id=f95dc008&scoped=true"
import script from "./TeamLibrary.vue?vue&type=script&lang=js"
export * from "./TeamLibrary.vue?vue&type=script&lang=js"

import "./TeamLibrary.vue?vue&type=style&index=0&id=f95dc008&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95dc008"]])

export default __exports__